<template>
  <div class="container">
    <div class="panel">
      <div class="panelContent" v-if="verified && user">
        <h1 class="text-center">Hi {{user.profile.firstname}}.</h1>
        <p class="text-center">Please set a password for your account, then login</p>
        <input class="form-input" type="password" v-model="password_a" placeholder="Password"/>
        <input class="form-input" type="password" v-model="password_b" placeholder="Confirm password"/>
        <button v-if="!success" class="btn btn-primary btn-block" :class="{loading: loading}" @click="setPassword">Set</button>
        <div v-if="error" class="toast toast-error" style="margin-top:10px;">
          <div class="text-center">{{error}}</div>
        </div>
        <div v-if="success" class="toast toast-success" style="margin:10px 0;">
          <div class="text-center">Success</div>
        </div>
        <a v-if="success" href="/" class="nextStep">Next <i class="icon icon-forward"></i></a>
      </div>
    </div>
  </div>   
</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'setPassword',
  data () {
    return {
      code: '',
      verified: false,
      user: null,
      password_a: '',
      password_b: '',
      loading: false,
      success: false,
      error: ''
    }
  },
  created: function () {
    this.code = window.location.toString().split('/').pop()
    console.log(this.code)
    axios.post('/api/users/verify/' + this.code)
    .then(res => {
      if (res.status === 200) {
        this.verified = true
        this.user = res.data
      }
    })
  },
  methods: {
    setPassword: function () {
      this.error = ''
      this.success = false
      if (this.password_a !== this.password_b) {
        this.error = 'Passwords do not match'
        return
      }
      if (!this.password_a.length) {
        this.error = 'Empty password'
        return
      }
      this.loading = true
      axios.post('/api/users/setpassword', {
        code: this.code,
        password: this.password_a
      }).then(res => {
        if (res.status === 200) {
          this.loading = false
          this.success = true
        }
      }).catch(e => {
        this.loading = false
        this.error = e.response.data
      })
    }
  }
}
</script>
<style scoped>
/*.background {
    position: absolute;
    height: 100%;
    background: url(../../assets/pocketlegal.png) no-repeat #0c5b9c;
    background-size: 200px;
    background-position: center 2em;
    max-width: 100%;
    left: 0;
    top: 0;
    right: 0;
}*/
.container {
  position: absolute;
  height: 100%;
  background: #0c5b9c;
  max-width: 100%
}
.panel {
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: 0%;
  width: 400px;
  height: calc(200px + 9em);
  margin: auto;
  border: none;
  background: url(../../assets/pocketlegal.png) top center no-repeat;
  background-size: 50%;
  padding: 9em 0 0 0;
}
.panel-title {
    color: #fff;
}
.panel-subtitle {
    color: #fff;
}
h1.text-center,
p.text-center  {
  color: #fff
}
.form-input {
  border: none;
  border-radius: 0;
  border-bottom: 1px solid rgba(255,255,255,0.4);
  background: none;
  color: #fff
}
.form-input:not(:placeholder-shown):invalid {
  color: #fff;
  border: inherit
}
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus
input:-webkit-autofill, 
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  border: inherit;
  -webkit-text-fill-color: #fff;
  -webkit-box-shadow: 0 0 0px 1000px #0c5b9c inset;
  transition: background-color 5000s ease-in-out 0s;
  border-bottom: 1px solid rgba(255,255,255,0.4);
}
.btn.btn-primary {
  background: rgba(0, 0, 0, 0);
  /*border: 1px solid #56e6b2;*/
  margin: 1em 0 0 0;
  border-radius: 0;
  background-color: #56e6b2;
  color: inherit;
  height: 55px;
}
.btn.btn-primary:hover,
.btn.btn-primary:focus {
  background: transparent;
  border: 1px solid #fff;
}
a.nextStep {
  color: #fff;
  font-size: 2em
}
a.nextStep:hover {
  color: #ccc!important;
  text-decoration: none;
  padding: 5px 0 0 0
}
@media (max-width: 768px) {
  .panel {
    width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// setPassword.vue?3a8b8834